import { render, staticRenderFns } from "./CommunicationGroup.vue?vue&type=template&id=6d70b9e5&"
import script from "./CommunicationGroup.vue?vue&type=script&lang=js&"
export * from "./CommunicationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports